import "./category-slider/category-slider";
import "./faq/terms-of-condition";
import "./heading-shop/heading-shop";
import "./mega-menu-header/mega-menu-header";
import "./my-account/hide-footer-and-breadcrumb-on-login-register";
import "./product-category/product-category";
import "./product-filter/product-filter";
import "./product-gallery/product-gallery";
import "./product-sort/product-sort";
import "./slider-header-usps/slider-header-usps.js";
import "./slider-product-slick/slider-product-slick";
import "./slider-related-product/slider-related-product";
import "./woocommerce/auto-scroll-offset";
import "./woocommerce/woocommerce-pagination";
